import React from 'react'
import '../styles/Shop.css'
export default function Shop() {
  return (
    <div className='Shop_container'>
        <h1>To get your very own 'brew banner' visit <a href="https://opensea.io/Brewing_Banner_Project"><span>OpenSea</span></a></h1>
    </div>
  )
}
